import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Notification, NotificationState } from '@platform-frontend/util';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslocoErrorSpecification } from './transloco-error-specification';

@Injectable({ providedIn: 'root' })
export class NotificationErrorProvider {
  constructor(private store: Store) {}

  notifications$: Observable<Notification[]> = this.store.select(NotificationState.errorNotifications);

  getErrorSpecification(ignore: string[] = [], buttonClickHandler?: () => void, buttonName?: Observable<string>): Observable<TranslocoErrorSpecification> {
    return this.notifications$.pipe(
      map(notifications => notifications.filter(notification => !ignore.includes(notification.message.key))),
      map(notifications => this.buildErrorSpec(notifications, buttonClickHandler, buttonName))
    );
  }

  private buildErrorSpec(notifications: Notification[], buttonClickHandler?: () => void, buttonName?: Observable<string>): TranslocoErrorSpecification {
    const hasNoActions = this.hasNoActions(notifications);
    return {
      type: 'transloco',
      descriptions: notifications.length > 0 ? notifications.map(notification => notification.message) : undefined,
      buttonName: buttonClickHandler && hasNoActions ? buttonName : null,
      buttonClick: buttonClickHandler && hasNoActions ? () => buttonClickHandler() : null
    };
  }

  private hasNoActions(notifications: Notification[]): boolean {
    return notifications.every(notification => notification.options.spinnerInclusiveActions.length === 0);
  }
}
